const assert = require('assert');
const url = require('url');
const flow = require('lodash/fp/flow');
const get = require('lodash/fp/get');
const has = require('lodash/fp/has');
const property = require('lodash/fp/property');
const split = require('lodash/fp/split');
const trimChars = require('lodash/fp/trimChars');
const stubData = require('../../stubs/api');
const memoizer = require('./utils/request-memoizer');
const cliOpts = require('../../utils/cli-opts');

function request(config) {
  const path = flow(
    property('url'),
    url.parse,
    property('pathname'),
    trimChars('/'),
    split('/')
  )(config);

  if (cliOpts.console) {
    // console.log();
    // console.log();
    // console.log();
    // console.log();
    // console.log('URL:', config.url);
    // console.log('-');
    // console.log('Request:', config);
    // console.log('[ '+Date()+' ]'+ ' Request: ',config.url,' ', JSON.stringify(config));
  }
  console.log('[ ' + Date() + ' ]' + ' Request: ', config.url, ' ', config);

  assert(has(path, stubData), `API stub data does not include data for: ${path.join('/')}`);

  const response = get([...path], stubData);
  const body = response.body;
  console.log('-');
  let consoleResponse = '[ ' + Date() + ' ]' + ' Response string : ' + config.url;
  console.log('Response string : ', consoleResponse);
  if (cliOpts.console) {
    // console.log('-');
    // let consoleResponse = '[ '+Date()+' ]'+ ' Response string : '+ config.url +' '+JSON.stringify(body);
    // console.log(consoleResponse.slice(0,500));
  }
  console.log('-');
  console.log('Response body: ', JSON.stringify(body || null).slice(0, 500));

  if (response.statusCode !== 200 && response.statusCode !== 201 &&
    response.statusCode !== 400 && response.statusCode !== 401 &&
    response.statusCode !== 417 && response.statusCode !== 304 &&
    response.statusCode !== 405
  ) {
    return Promise.resolve({
      statusCode: response.statusCode,
      statusMessage: response.statusMessage,
          // WMCE-62205 Do not expose request headers, cookies, or backend payloads via Falcor.
          // request: config,
          // body,
    });
  }

  return Promise.resolve(body);
}

module.exports = memoizer()(request);
